var cutText = function (str, max) {
    if (str.length > max) {
        return str.substring(0, max - 1) + "...";
    }
    return str;
};
export { cutText };
